import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { createSelector } from 'reselect'

import {
  Button,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Tooltip,
  IconButton
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import Room from '@material-ui/icons/Room'

import { useLiterals } from '~/components/Literals'
import ProductImageThumb from '~/components/ProductImageThumb'

import track from '~/track'
import actions from '~/actions'

import searchAlertIcon from '../../assets/icons/search-alert.svg'

const useStyles = makeStyles(() => ({
  title: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid #E0E0E0'
  },
  rootBackground: { position: 'absolute' }
}))

const selector = createSelector(
  (state) => state.app,
  (state) => state.dialog,
  (...args) => args
)

export default function EcommerceNotFound({ product, onClose }) {
  const [app, dialog] = useSelector(selector, shallowEqual)

  const dialogEcommerceNotFoundRef = useRef(null)

  const dispatch = useDispatch()
  const classes = useStyles()
  const history = useHistory()

  const { getLiteral } = useLiterals()
  const { view } = app

  const getSlug = (value) => {
    return value
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
  }

  const findStore = () => {
    track('naoLocalizadoLojaOnline-CliqueRedirect', { category: 'menu', name: product?.name })
    history.push(`/produto/${getSlug(product?.name)}/${product?.gtin}`)
  }

  useEffect(() => {
    if (dialogEcommerceNotFoundRef.current) {
      const { dialogs } = dialog

      if (dialogs.length) {
        const modalRootFindProduct = document.getElementById('dialog-find-product')

        modalRootFindProduct.style.display = 'none'
      }
    }
  }, [dialog, dialogEcommerceNotFoundRef])

  return (
    <Dialog
      maxWidth="sm"
      ref={dialogEcommerceNotFoundRef}
      open={!!product}
      onClose={onClose}
      style={{ position: 'absolute' }}
      PaperProps={{ 'data-cy': 'dialog-ecommerce-notfound' }}
      BackdropProps={{
        classes: { root: classes.rootBackdrop }
      }}
    >
      <DialogTitle
        disableTypography
        className={classes.title}
        onLoad={() => {
          dispatch(actions.dialog.error(true))
          track('naoLocalizadoLojaOnline', { category: 'menu' })
        }}
      >
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 8
          }}
        >
          <Typography style={{ fontWeight: 500 }}>{getLiteral('2339')}</Typography>
          <Tooltip
            title={getLiteral('1251')}
            placement="bottom"
            PopperProps={{ container: document.getElementById('gofind-finder') || document.body }}
          >
            <IconButton aria-label={getLiteral('1251')} size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid
          container
          alignItems="center"
          wrap="nowrap"
          style={{ padding: 16, borderTop: '1px solid #CCC' }}
        >
          <ProductImageThumb product={{ imageurl: product?.imageurl }} />
          <Typography variant="body1" style={{ marginLeft: 16 }}>
            {product?.name}
          </Typography>
        </Grid>
      </DialogTitle>

      <DialogContent align="center" dividers style={{ backgroundColor: '#EEEBEB' }}>
        <img src={searchAlertIcon} alt="pesquisa" style={{ marginBottom: 16, marginTop: 8 }} />

        <Typography variant="body1" gutterBottom>
          {getLiteral('2389')}
        </Typography>

        {view !== 'VIEW_STORES' && (
          <>
            <Typography variant="body1" gutterBottom>
              {getLiteral('2390')}:
            </Typography>
            <Button
              onClick={findStore}
              variant="outlined"
              style={{ borderColor: '#000', borderWidth: 2, marginTop: 8 }}
            >
              <Room style={{ marginRight: 8 }} />
              {getLiteral('2391')}
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
